// Mapping from top-level category IDs to placeholder image URLs in public folder
// Files are in WebP (primary) and PNG (fallback) formats under public/images/placeholders/
// All files are lowercase with underscores

export const CATEGORY_PLACEHOLDER_IMAGES = {
  'local-producers': {
    webp: '/images/placeholders/local_producers.webp',
    png: '/images/placeholders/local_producers.png',
  },
  'shop-and-delivery-boxes': {
    webp: '/images/placeholders/shops_and_delivery_boxes.webp',
    png: '/images/placeholders/shops_and_delivery_boxes.png',
  },
  'markets_events': {
    webp: '/images/placeholders/markets_festivals_and_country_shows.webp',
    png: '/images/placeholders/markets_festivals_and_country_shows.png',
  },
  'producers-places': {
    webp: '/images/placeholders/local_producer_places_to_stay.webp',
    png: '/images/placeholders/local_producer_places_to_stay.png',
  },
  'farm-to-fork-dining': {
    webp: '/images/placeholders/farm_to_for_dining.webp',
    png: '/images/placeholders/farm_to_for_dining.png',
  },
  experiences: {
    webp: '/images/placeholders/experiences.webp',
    png: '/images/placeholders/experiences.png',
  },
};

/**
 * Get placeholder sources (WebP + PNG fallback) for a category
 * @param {string} categoryId - Category ID
 * @returns {object} { webp, png } URLs
 */
export const getCategoryPlaceholderSources = categoryId =>
  CATEGORY_PLACEHOLDER_IMAGES[categoryId] || CATEGORY_PLACEHOLDER_IMAGES['local-producers'];

/**
 * Get PNG fallback URL (for img src)
 * @param {string} categoryId - Category ID
 * @returns {string} PNG URL
 */
export const getCategoryPlaceholderSrc = categoryId =>
  getCategoryPlaceholderSources(categoryId).png;

/**
 * Render a <picture> element with WebP + PNG fallback
 * @param {string} categoryId - Category ID
 * @param {object} props - HTML props (className, alt, etc.)
 * @returns {JSX.Element} Picture element
 */
export const renderPlaceholderPicture = (categoryId, props = {}) => {
  const sources = getCategoryPlaceholderSources(categoryId);
  const { alt = '', className = '', ...rest } = props;

  return (
    <picture>
      <source srcSet={sources.webp} type="image/webp" />
      <source srcSet={sources.png} type="image/png" />
      <img
        src={sources.png}
        alt={alt}
        className={className}
        {...rest}
      />
    </picture>
  );
};
